import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import { FaBullseye, FaHandshake, FaRocket, FaUsers } from "react-icons/fa";

const AboutUs = () => {
  return (
    <React.Fragment>
      <Header />

      <div className="about-page">
        <Helmet>
          <title>About Us - Topup Connect</title>
          <meta
            name="description"
            content="Learn about Topup Connect, a digital service platform by CHOTTU TELECOM offering mobile recharge, bill payment, and utility services."
          />
        </Helmet>

        <section className="about-hero">
          <div className="container">
            <h1>About Topup Connect</h1>
            <p>
              Powering digital payments with speed, trust, and simplicity —
              brought to you by CHOTTU TELECOM
            </p>
          </div>
        </section>

        <div className="container about-container">
          <section className="our-story">
            <h2>Our Story</h2>
            <p>
              Topup Connect is a digital recharge and bill payment platform
              owned and operated by <strong>CHOTTU TELECOM</strong>,
              headquartered in West Bengal. We started with a vision to simplify
              digital payments in semi-urban and rural areas, making essential
              services like mobile recharges and utility bill payments more
              accessible to everyone.
            </p>
            <p>
              Since our launch, we’ve helped thousands of users across Eastern
              India seamlessly manage their digital transactions — quickly,
              securely, and affordably.
            </p>
          </section>

          <section className="our-mission">
            <h2>Our Mission</h2>
            <div className="mission-cards">
              <div className="mission-card">
                <div className="mission-icon">
                  <FaBullseye />
                </div>
                <h3>Our Vision</h3>
                <p>
                  To be the most accessible and trusted recharge and digital
                  utility platform across India’s growing Bharat segment.
                </p>
              </div>

              <div className="mission-card">
                <div className="mission-icon">
                  <FaHandshake />
                </div>
                <h3>Our Promise</h3>
                <p>
                  Reliable services, honest pricing, and complete transparency —
                  with support whenever you need it.
                </p>
              </div>

              <div className="mission-card">
                <div className="mission-icon">
                  <FaUsers />
                </div>
                <h3>For the People</h3>
                <p>
                  We aim to bridge the digital divide by making online
                  transactions easy for every Indian — especially in Tier 2 and
                  Tier 3 towns.
                </p>
              </div>
            </div>
          </section>

          <section className="why-choose-us">
            <h2>Why Choose Topup Connect?</h2>
            <div className="features-list">
              <div className="feature-item">
                <div className="feature-icon">
                  <FaRocket />
                </div>
                <div className="feature-text">
                  <h3>Lightning-Fast Transactions</h3>
                  <p>
                    Our platform ensures instant processing for all your
                    recharges and bill payments.
                  </p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <FaHandshake />
                </div>
                <div className="feature-text">
                  <h3>Trusted Network</h3>
                  <p>
                    Thousands of customers across West Bengal and beyond rely on
                    Topup Connect every day.
                  </p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <FaUsers />
                </div>
                <div className="feature-text">
                  <h3>24/7 Customer Support</h3>
                  <p>
                    Whether it’s a failed recharge or a billing query, our
                    support team is here for you — round the clock.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="our-team">
            <h2>Our Commitment</h2>
            <p>
              At Topup Connect, we’re not just about transactions — we’re about
              trust. Every feature we build and every update we make is designed
              to serve you better. As a CHOTTU TELECOM initiative, we’re
              committed to ensuring digital convenience reaches the last mile.
            </p>
            <p>
              With strong values, a customer-first approach, and the latest
              technology backing us, we continue to grow as a dependable
              platform in India’s digital service landscape.
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </React.Fragment>
  );
};

export default AboutUs;
